export default ({
  values: {
    condition: {
      termOne: { condition },
    },
  },
}) => condition
